// hotelSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllHotelFilterData } from '../../services/hotel/hotelServices';


export const fetchAllHotelListFilter = createAsyncThunk(
    'hotelFilter/fetchAllHotelListFilter',
    async ({ reqBody, params }, thunkAPI) => {
        try {
            const response = await getAllHotelFilterData(reqBody, params);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const HotelsResultFilterSlice = createSlice({
    name: 'hotelFilter',
    initialState: {
        filterResultData: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllHotelListFilter.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllHotelListFilter.fulfilled, (state, action) => {
                state.filterResultData = action.payload;
                state.loading = false;
            })
            .addCase(fetchHotelPrice.fulfilled, (state, action) => {
                const { hotelCode, price, error } = action.payload;
                state.list = state.list.map(hotel =>
                  hotel.hotelCode === hotelCode
                    ? {
                        ...hotel,
                        price: error ? null : price,
                        isLoadingPrice: false,
                      }
                    : hotel
                );
              })
            .addCase(fetchAllHotelListFilter.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default HotelsResultFilterSlice.reducer;
